module.exports = { "default": require("core-js/library/fn/number/min-safe-integer"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/babel-runtime/core-js/number/min-safe-integer.js
// module id = 599
// module chunks = 0